const genHorizontalStyle = (token) => {
    const { componentCls } = token;
    const stepsItemCls = `${componentCls}-item`; // .sry-steps-item
    return {
        [`${componentCls}-horizontal`]: {
            [`${stepsItemCls}-tail`]: {
                transform: "translateY(-50%)",
            },
        },
    };
};
export default genHorizontalStyle;
